module.exports = __webpack_public_path__ + "img_loginbg.23ec121fedf16876975f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_loginbg.png
// module id = 1485
// module chunks = 0